import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AiAnalystScopeService } from '../services/ai-analyst-scope.service';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AiAnalystAdminGuard implements CanActivate {
    constructor(
        private aiAnalystScopeService: AiAnalystScopeService,
        private authService: AuthService,
        private router: Router,
    ) {}

    canActivate(): boolean {
        if (this.aiAnalystScopeService.firstAdminTabRoute() != null) {
            return true;
        }
        this.router.navigate([this.authService.getLandingPageUrl()]);
        return false;
    }
}
